<!-- 景点推荐  mjs -->
<template>
  <div class="travelServe scenicspotContainer">
    <banner/>
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">景点推荐</a>
      </div>
    </div> -->
    <crumbs/>
    <div class="container">
      <div class="leftPart pb100 fl">
        <div class="labelBox">
          <type-screen modelType="scenicspot" :menu-id="menuId" @typeObj="selectType"/>
        </div>
        <div class="scenicspotList">
          <div class="scenicspotItem" @click="godetail(item)" v-for="item in scenicspotlist" :key="item.id">
            <div class="itemimg">
              <span v-if="item.servearr[0] !== undefined "><i>{{item.servearr.length>0 ? item.servearr[0]:''}}</i></span>
              <img :src="getImage(item.image)"  alt="">
            </div>
            <div class="itemtxt">
              <div class="title clearfix">
                <h2><span v-if="item.ticketFree==0">免费</span>{{item.spotName}}</h2>
                <h3><span>{{item.keyWord}}</span></h3>
              </div>
              <div class="desc" v-html="item.introduction"></div>
              <div class="itemfun clearfix">
                <span class="address textover">地区：{{item.place}}</span>
                <span class="detail">详情<i></i></span>
                <span class="browsevalue">
                    <i></i><b>{{item.pv}}</b>
                </span>
              </div>
            </div>

          </div>
        </div>
        <nodata v-show="nodataflag"/>
        <!-- 分页器 -->
        <el-pagination
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="total"
          background
          @current-change="currentChange"
          class="pagemodel1">
        </el-pagination>
      </div>
      <div class="rightPart fr">
        <rightBox></rightBox>
      </div>

    </div>
  </div>
</template>

<script>
import star from '@/components/amount/star'
import crumbs from '@/components/crumbs/index'
import {getscenicspotlist} from '@/api/scenicspot/index'
import rightBox from '../../components/travelRight/index'
import { getListAmount } from '@/api/datavolume/index'
import { getTypeList } from '@/api/typescreen/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
import banner from '@/components/banner/index'
export default {
  name: 'scenicspot',
  meta: {
    showHeader: true
  },
  components: {
    rightBox, typeScreen, crumbs, nodata, star, banner
  },
  data () {
    return {
      total: 0,
      scenicparams: {
        page: 1,
        limit: 10,
        menuId: '',
        areaType: '',
        subject: ''
      },
      phoneNum: '',
      menuId: '',
      nodataflag: false,
      scenicspotlist: [],
      typeParams: {
        menuId: '',
        dictParentCode: 'scenicSpotSubject'
      }
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.typeParams.menuId = this.$route.query.columnId
    this.scenicparams.menuId = this.$route.query.columnId
    this.phoneNum = this.$cookie.get('wlymobilephone')
    this.getsceniclist()
  },
  methods: {
    changeStar (val) {
      this.scenicspotlist.forEach(item => {
        if (item.id === val.id) {
          item.star = val.count
          item.isStar = val.isSelect
        }
      })
    },
    defaultamout (list) {
      list.forEach(item => {
        if (item.collect === undefined) item.collect = 0
        if (item.isCollect === undefined) item.isCollect = 'false'
        if (item.star === undefined) item.star = 0
        if (item.isStar === undefined) item.isStar = 'false'
        if (item.pv === undefined) item.pv = 0
        if (item.servearr === undefined) item.servearr = []
        if (item.labelarr === undefined) item.labelarr = []
      })
      getTypeList(this.typeParams).then(val1 => {
        // let labelarr = []
        let service = val1.data.data.dictType.scenicSpotSubject.list
        // let labels = val1.data.data.dictType.hotelLabel.list
        console.log(service)
        list.forEach((val, index) => {
          let servearr = []
          // let labelarr = []
          let serviceBinkList = val.subject
          // let labelBinkList = val.labelBinkList
          // serviceBinkList.forEach((dd) => {
          service.forEach((demo, i) => {
            if (serviceBinkList === demo.dictCode) {
              servearr.push(demo.dictName)
            }
          })
          // })
          val.servearr = servearr
        })
      })
    },
    getsceniclist () {
      getscenicspotlist(this.scenicparams).then(res => {
        console.log(res)
        this.total = res.data.data.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
        // let that = this
        const params = {
          p: this.$cookie.get('wlymobilephone')
        }

        getListAmount(this.menuId, params).then(res1 => {
          console.log(res1, 'res1')
          if (res1.data.data.length !== 0) {
            res1.data.data.forEach(item => {
              res.data.data.rows.forEach(val => {
                if (item.dataId === val.id) {
                  val.collect = item.collect
                  val.isCollect = item.isCollect
                  val.pv = item.pv
                  val.isStar = item.isStar
                  val.star = item.star
                }
              })
            })
            this.defaultamout(res.data.data.rows)
          } else {
            this.defaultamout(res.data.data.rows)
          }
          this.scenicspotlist = res.data.data.rows
        })
      })
    },
    selectType (obj) {
      this.scenicparams.areaType = obj.areaType
      this.scenicparams.subject = obj.subject
      this.scenicspotlist = []
      this.getsceniclist()
    },
    godetail (val) {
      if (val.link !== undefined && val.link !== '') {
        window.open(val.link)
      } else {
        this.$router.push({
          path: '/scenicspotdetail',
          query: {id: val.id, columnId: this.menuId}
        })
      }
    },
    currentChange (val) {
      // 当前的页
      this.scenicparams.page = val
      this.scenicspotlist = []
      this.getsceniclist()
    },

    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>

@import "../../assets/common/scss/travleServes.scss";
.alpraised i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px 0px !important;
}
.alcollected i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px -64px !important;
}
.praise{
  float: right !important;
  position: relative;
  top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/view/scenicspot/list.vue